import React, { useState } from 'react';
import Modal from 'react-modal';
import ClearIcon from '@mui/icons-material/Clear';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-40%',
    border:'none',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    transform: 'translate(-50%, -50%)',
  },
};

const textStyle = {
    content: {
      color: '#0C1458',
      textAlign: 'center',
      padding: '50px',
    },
  };
  const text = {
    content: {
      color: '#0C1458',
      textAlign: 'center',
      padding: '30px',
      fontSize:"10px",
    },
  };

  const modalButton = {
    content:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position:'absolute',
        right:'10px',
        background:'transparent',
        border:'none',
        color:"red"
    }
  }


export const RegisterSuccessModal =({modalIsOpen, setIsOpen})=> {
  let subtitle;



  const afterOpenModal = ()=> {
    subtitle.style.color = '#0C1458';
  }

  const closeModal =()=> {
    setIsOpen(false);
  }


  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <button style={modalButton.content} onClick={closeModal}><span>close</span><ClearIcon/></button>

        <h2 style={textStyle.content} ref={(_subtitle) => (subtitle = _subtitle)}>👍 Your Registration was Successful!</h2>
        <p style={text.content}>Please check your email inbox to copy your Referral link</p>
        
      </Modal>
    </div>
  );
}